import type React from "react";
import { useState } from "react";
import { Spinner } from "@/components/Spinner";
import { Button } from "@/components/ui/button";
import {
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { EmailLink } from "@/shared/components/EmailLink";
import { SUPPORT_EMAIL } from "@/shared/constants/common";
import {
	buttonClassNames,
	formHeaderClassNames,
} from "@/shared/constants/customStyleSets";
import type { OnCancelSubscriptionType } from "../../../helpers/onCancelSubscription/onCancelSubscription";

type Props = {
	cancelSubscription: (
		setCancelLoader: (value: boolean) => void,
	) => ReturnType<OnCancelSubscriptionType>;
	cancelError: unknown;
};

export const CancelSubscriptionForm: React.FC<Props> = ({
	cancelSubscription,
	cancelError = null,
}) => {
	const [cancelLoader, setCancelLoader] = useState(false);

	return (
		<DialogContent data-testid="cancel-form">
			<DialogHeader>
				<DialogTitle className={formHeaderClassNames}>
					You are about to cancel your subscription
				</DialogTitle>
			</DialogHeader>

			<DialogDescription className="text-center text-foreground">
				You will lose all of your premium features unfortunately, but you can
				still use the site as a Bronze member at no charge.
				<br /> <br />
				Click the button below to confirm cancellation.
			</DialogDescription>

			<DialogFooter className="sm:justify-center">
				<Button
					data-testid="cancel-subscription-confirm"
					type="button"
					variant="secondary"
					className={buttonClassNames}
					disabled={cancelLoader}
					onClick={() => cancelSubscription(setCancelLoader)}
				>
					Confirm cancellation {cancelLoader && <Spinner />}
				</Button>
			</DialogFooter>

			{Boolean(cancelError) && (
				<p className="text-red-500" data-testid="cancel-error">
					Unable to cancel subscription. Please try again later or contact{" "}
					<EmailLink email={SUPPORT_EMAIL} />
				</p>
			)}
		</DialogContent>
	);
};
